import { debounce } from "lodash-es";

import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["lon", "lat", "select"];
  static values = { url: String };

  connect() {
    this._debouncedFetch = debounce(() => this.fetchLayers(), 500);
    this._inputListener = () => this._debouncedFetch();
    if (this.hasLonTarget) this.lonTarget.addEventListener("input", this._inputListener);
    if (this.hasLatTarget) this.latTarget.addEventListener("input", this._inputListener);
    this._debouncedFetch();
  }

  disconnect() {
    if (this.hasLonTarget) this.lonTarget.removeEventListener("input", this._inputListener);
    if (this.hasLatTarget) this.latTarget.removeEventListener("input", this._inputListener);
  }

  fetchLayers() {
    if (!this.urlValue || !this.hasSelectTarget || !this.hasLonTarget || !this.hasLatTarget) return;
    const lon = this.lonTarget.value;
    const lat = this.latTarget.value;
    if (!lon || !lat) return;

    const select = this.selectTarget;
    const currentValue = select.value;
    const currentText = select.options[select.selectedIndex]?.text;
    select.disabled = true;
    select.innerHTML = `<option>${select.dataset.loadingText || "…"}</option>`;

    fetch(`${this.urlValue}?lat=${lat}&lon=${lon}`, { credentials: "same-origin" })
      .then((r) => r.json())
      .then((layers) => this.updateSelect(layers, currentValue, currentText))
      .catch(() => this.updateSelect([], currentValue, currentText))
      .finally(() => {
        select.disabled = false;
      });
  }

  updateSelect(layers, currentValue, currentText) {
    const select = this.selectTarget;
    const prompt = select.dataset.prompt || "";

    select.innerHTML = "";
    const blankOption = document.createElement("option");
    blankOption.value = "";
    blankOption.text = prompt;
    select.appendChild(blankOption);

    layers.forEach((layer) => {
      const option = document.createElement("option");
      option.value = layer.id;
      option.text = `${layer.display_name} (${layer.distance_km} km)`;
      select.appendChild(option);
    });

    if (currentValue) {
      const alreadyPresent = layers.some((l) => String(l.id) === String(currentValue));
      if (!alreadyPresent && currentText) {
        const option = document.createElement("option");
        option.value = currentValue;
        option.text = currentText;
        select.appendChild(option);
      }
      select.value = currentValue;
    } else if (layers.length > 0) {
      select.value = layers[0].id;
    }
  }
}
